import styled from 'styled-components/macro';

export const StopInformation = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  column-gap: ${(props) => props.theme.spacing(10)};
  padding: ${(props) => props.theme.spacing(20)};
`;
